import styled from 'styled-components';
import { ifProp } from 'styled-tools';
import { key } from 'styled-theme';

import { media } from '../../../../utils/styles';
import { TabContainerProps } from '../../types';

export default styled.div<{ active?: boolean }>`
  flex: 1;
  cursor: pointer;
  font-size: 20px;
  font-weight: ${ifProp('active', 500, 400)};
  z-index: ${ifProp('active', 2, 0)};
  border-top-right-radius: ${key('sizes.borderRadius')};
  border-top-left-radius: ${key('sizes.borderRadius')};

  &,
  > div {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
  }

  &:before {
    content: '';
    display: block;
    z-index: 0;
    box-shadow: ${key('outlines.shadow.default')};
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(
      100% -
        ${(props: TabContainerProps) =>
          props.theme.sizes.shadowSpace.small + 2}px
    );

    ${media.moreThan('md')`
      height: calc(
        100% -
          ${(props: TabContainerProps) =>
            props.theme.sizes.shadowSpace.large + 2}px
      );
    `};

    border-top-right-radius: ${key('sizes.borderRadius')};
    border-top-left-radius: ${key('sizes.borderRadius')};
  }

  > div {
    width: 100%;
    height: 100%;
    z-index: 0;
    padding: 10px 10px
      ${(props: TabContainerProps) =>
        props.theme.sizes.shadowSpace.small + 10}px
      10px;

    ${media.moreThan('md')`
      padding: 20px 40px
        ${(props: TabContainerProps) =>
          props.theme.sizes.shadowSpace.large + 20}px
        40px;
    `};

    background: ${ifProp(
      'active',
      key('colors.white'),
      key('backgrounds.primary'),
    )};

    border-top-right-radius: ${key('sizes.borderRadius')};
    border-top-left-radius: ${key('sizes.borderRadius')};
  }
`;
